module.exports = __webpack_public_path__ + "img/company_pic.99585c79.png";